import { createGenericAsyncThunk } from '../../../../../store/features/generic';
import { selectPageConfig } from '../../../../../store/features/pageConfig';
import {
  PricingBillingDetails,
  SitePricingBillingDetailsParams,
  UpdateSitePricingBillingDetailsParams,
} from './types';
import { fetchSitePricingBookingClosed } from '../bookingClosed';

export const fetchSitePricingBillingDetails = createGenericAsyncThunk<
  PricingBillingDetails,
  SitePricingBillingDetailsParams
>(
  'sitePricingBillingDetails/fetchSitePricingBillingDetails',
  async (params, { extra, rejectWithValue, getState, dispatch }) => {
    const { basketId } = params;
    const { siteId } = selectPageConfig(getState());

    const response = await extra.ajax.get(
      `/caas/commerce/v1/site/${siteId}/purchase/${basketId}/billing-details`,
      {
        headers: {
          'Accept-Language': extra.headers['Accept-Language'],
          'Published-State': extra.headers['Published-State'],
        },
      },
    );

    const data: PricingBillingDetails = await response.json();

    if (response.status !== 200) {
      if (response.status === 423) {
        dispatch(fetchSitePricingBookingClosed());
      }

      return rejectWithValue(extra.processRejectedValue(response, data));
    }

    return data;
  },
);

export const updateSitePricingBillingDetails = createGenericAsyncThunk<
  PricingBillingDetails,
  UpdateSitePricingBillingDetailsParams
>(
  'sitePricingBillingDetails/fetchSitePricingBillingDetails',
  async (params, { extra, rejectWithValue, getState }) => {
    const { basketId, values } = params;
    const { siteId } = selectPageConfig(getState());

    const response = await extra.ajax.put(
      `/caas/commerce/v1/site/${siteId}/purchase/${basketId}/billing-details`,
      values,
      {
        headers: {
          'Accept-Language': extra.headers['Accept-Language'],
          'Published-State': extra.headers['Published-State'],
        },
      },
    );

    const data: PricingBillingDetails = await response.json();

    if (response.status !== 200) {
      return rejectWithValue(extra.processRejectedValue(response, data));
    }

    return data;
  },
);
